module.exports = __webpack_public_path__ + "img/20190827144522449.4fbe183a.jpg";